import React, { useEffect } from "react";
import styles from "./StepperStyle.module.scss";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import { StepButton } from "@material-ui/core";

import StepLabel from "@material-ui/core/StepLabel";
import rightArrow from "assets/icons/right.svg";
import { useLocation } from "react-router-dom";
import { history } from "helpers";
import { connect } from "react-redux";

const signUpStepper = makeStyles((theme) => ({}));

function getStepsNew() {
  return ["Basic", "Education", "Payment"];
}

function getSteps() {
  return ["Basic", "Education", "Appointment", "Payment"];
}

const VerticalLinearStepper = ({ DoctorTypeSet }) => {
  const classes = signUpStepper();
  const [activeStep, setActiveStep] = React.useState();

  const location = useLocation();

  const queryParams = new URLSearchParams(window.location.search);
  const steps = DoctorTypeSet == "GP" ? getStepsNew() : getSteps();

  const stepperData = {
    "/profile/basic-details": 0,
    "/profile/education-details": 1,
    "/profile/appointment": 2,
    "/profile/payment-details": 3,
  };
  const stepperDataNew = {
    "/profile/basic-details": 0,
    "/profile/education-details": 1,
    "/profile/payment-details": 2,
  };

  const stepperURL = {
    Basic: "/profile/basic-details",
    Education: "/profile/education-details",
    Appointment: "/profile/appointment",
    Payment: "/profile/payment-details",
  };
  const stepperURLNew = {
    Basic: "/profile/basic-details",
    Education: "/profile/education-details",
    Payment: "/profile/payment-details",
  };

  const code = stepperData[location?.pathname] ?? queryParams.get("step");
  const codeNew = stepperDataNew[location?.pathname] ?? queryParams.get("step");

  useEffect(() => {
    if (DoctorTypeSet == "GP") {
      setActiveStep(codeNew);
    } else {
      setActiveStep(code);
    }
  }, []);

  return (
    <div>
      <div>
        <div className={classes.root}>
          <Stepper
            activeStep={Number(activeStep)}
            orientation="horizontal"
            style={{ background: "none", cursor: "pointer" }}
          >
            {steps.map((label, index) => (
              <Step
                key={index}
                onClick={() => {
                  if (DoctorTypeSet == "GP") {
                    if (stepperURLNew[label]) {
                      history.push(stepperURLNew[label]);
                    }
                  } else {
                    if (stepperURL[label]) {
                      history.push(stepperURL[label]);
                    }
                  }
                }}
              >
                <StepLabel
                  icon={
                    <span
                      style={{
                        color:
                          code == index || code > index ? "#FFFFFF" : "#545454",
                        background:
                          code == index || code > index
                            ? "#0E69C2"
                            : "transparent",
                        // padding: "0px 5px",
                        height: "23px",
                        width: "23px",
                        borderRadius: "50%",
                        border:
                          code == index || code > index
                            ? "transparent"
                            : "1.5px solid black",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "13px",
                        fontWeight: 700,
                      }}
                    >
                      {index + 1}
                    </span>
                  }
                >
                  {label}
                  {index + 1 == steps.length ? null : (
                    <img
                      src={rightArrow}
                      style={{ width: "20px", margin: "0px 10px" }}
                    />
                  )}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </div>
      </div>
    </div>
  );
};

//export default VerticalLinearStepper;
const mapState = (state) => ({
  DoctorTypeSet: state?.home?.selectedDoctorType,
});

export default connect(mapState, null)(VerticalLinearStepper);
